module.exports = __webpack_public_path__ + "img/Folie à deux.154d331d.webp";